<template>
  <div class="jumbotron text-white">
    <div class="container text-center">
      <h1>Programming for the puzzled</h1>
      <p>This page contains visual game like representations for puzzles from various sources.</p>
      <p>
        They are all made just for
      </p>
      <h3><BannerTextColor :msgs="['🤪 fun 🤪', '😯 interest 😯', '😊 joy 😊', '✨glory ✨']" /></h3>
      <p>
        Feel free to send me some
        <a href="mailto:info@schemiii.de">ideas or feedback</a>.
      </p>
    </div>
  </div>
</template>

<script>
import BannerTextColor from "@/components/BannerTextColor";
export default {
  name: "Home",
  components: {
    BannerTextColor
  }
};
</script>

<style scoped>
.jumbotron {
  background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.46) 0%,
      rgba(0, 0, 0, 0.46) 100%
    ),
    url("~@/assets/puzzle.jpg");
  background-size: cover;
  min-height: 850px;
}
</style>
